import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';
import * as RangeWithIdList from 'types/Accessory/Search/RangeWithIdList';

const rb = new ReducerBuilder<RangeWithIdList.Type>();
export const createAccessoryRangesReducerLoadedAction = rb.createActionForReducer(
	payloadReducer((x) => x),
	'AccessoryRanges/LoadedFromBackend'
);

export const accessoryRangesReducer = rb.createReducer();

const rbArchived = new ReducerBuilder<RangeWithIdList.Type>();
export const createAccessoryRangesArchivedReducerLoadedAction = rbArchived.createActionForReducer(
	payloadReducer((x) => x),
	'AccessoryRangesArchived/LoadedFromBackend'
);

export const accessoryRangesReducerArchived = rbArchived.createReducer();
